import NewsEditComponents from "../components/NewsEdit";
import useNews from "../hook/useNews";

const NewsEdit = () => {
  const newsProps = useNews();
  return <NewsEditComponents {...newsProps} />;
};

export default NewsEdit;